import Phaser from 'phaser';
import { showFeedbackOverlay } from './FeedbackOverlay';
import { GAME_W } from '../utils/MobileHelper';
import { FONT_BODY } from '../utils/Typography';

// === BOUTON FEEDBACK GLOBAL ===
// Petit bouton 💡 placé à gauche du bouton 🐛 dans chaque scène.
// Au clic : ouvre le formulaire de retour d'amélioration (DOM overlay).
// Pas d'attachements (pas de capture/save/logs) — un retour est moins
// urgent qu'un bug et n'a pas besoin de l'état précis du jeu.

export function addFeedbackButton(scene: Phaser.Scene): Phaser.GameObjects.Text {
  // Position : juste à gauche du bouton bug (qui est à GAME_W - 6)
  // On laisse 32px d'écart pour ne pas que les hitboxes se chevauchent.
  const btn = scene.add.text(GAME_W - 38, 6, '💡', {
    fontSize: '14px',
    fontFamily: FONT_BODY,
    backgroundColor: '#1a180a',
    padding: { x: 5, y: 3 },
  }).setOrigin(1, 0).setDepth(500).setAlpha(0.55);

  btn.setInteractive({ useHandCursor: true });
  btn.on('pointerover', () => btn.setAlpha(1));
  btn.on('pointerout', () => btn.setAlpha(0.55));
  btn.on('pointerdown', () => {
    showFeedbackOverlay(scene.scene.key);
  });

  return btn;
}
